import React from 'react';
import { cn } from '../../utils/cn';

export const ROLE_LABELS = {
  'super-admin': 'Super Admin',
  'content-creator': 'Content Creator',
  student: 'Student',
  parent: 'Parent',
};

const ROLE_STYLES = {
  parent: 'bg-violet-100 text-violet-800 ring-violet-200/60',
  student: 'bg-sky-100 text-sky-800 ring-sky-200/60',
  'content-creator': 'bg-amber-100 text-amber-900 ring-amber-200/60',
  'super-admin': 'bg-slate-200 text-slate-800 ring-slate-300/60',
};

export function RoleBadge({ role, className, size = 'sm' }) {
  const label = ROLE_LABELS[role] || role;
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full font-bold ring-1 ring-inset',
        size === 'sm' ? 'px-2 py-0.5 text-[10px] sm:text-xs' : 'px-2.5 py-1 text-xs',
        ROLE_STYLES[role] || 'bg-slate-100 text-slate-700 ring-slate-200/60',
        className
      )}
    >
      {label}
    </span>
  );
}
